import React, { useEffect, useState } from "react";
import {
  OPEN_COOKIE_SETTINGS,
  saveConsentToLocalStorage,
  applyCookieSettings,
  updateGoogleConsent,
} from "../../utils/cookieEvents";
import styles from "./CookiesSettings.module.css";

export default function CookieSettings(props) {
  const [isOpen, setIsOpen] = useState(false);
  // const [visible, setVisible] = useState(false);
  const [settings, setSettings] = useState({
    analytics: false,
    marketing: false
  });

  const handleSave = () => {
    const consent = {
      necessary: true,
      analytics: settings.analytics,
      marketing: settings.marketing,
      decision: "custom"
    };

    saveConsentToLocalStorage(consent);
    applyCookieSettings(consent);
    updateGoogleConsent(consent);
    setIsOpen(false);

    window.dispatchEvent(new Event("cookieConsentSaved"));
  };

  // 🔸 nasłuchujemy eventu z Footer
  useEffect(() => {
    const handleOpen = () => setIsOpen(true);
    window.addEventListener(OPEN_COOKIE_SETTINGS, handleOpen);
    return () => window.removeEventListener(OPEN_COOKIE_SETTINGS, handleOpen);
  }, []);

  if (!isOpen) return null; // jeśli nie otwarte — nic nie renderujemy
  // if (!visible) return null;

  return (
    <div
      className={styles.overlay}
      //   onClick={e => {
      //     if (e.target === e.currentTarget) setIsOpen(false);
      //   }}
    >
      <div className={styles.modal}>
        <h2>Ustawienia cookies</h2>
        <p>Włącz lub wyłącz kategorie ciasteczek.</p>

        <div className={styles.options}>
          <div className={styles.nece}>
            <label>
              <input type="checkbox" defaultChecked disabled /> Niezbędne
            </label>
            <p className={styles.description}>
              Dzięki nim strona działa sprawnie i możesz z niej bez problemu
              korzystać.
            </p>
          </div>
          <div className={styles.borderElement}>
            <label>
              <input
                type="checkbox"
                checked={settings.analytics}
                onChange={e =>
                  setSettings(prev => ({
                    ...prev,
                    analytics: e.target.checked
                  }))}
              />{" "}
              Analityczne
            </label>
            <p className={styles.description}>
              Dzięki nim wiemy, które treści są najbardziej interesujące dla
              odwiedzających i możemy stale poprawiać diałanie strony.
            </p>
          </div>
          <div className={styles.borderElement}>
            <label>
              <input
                type="checkbox"
                checked={settings.marketing}
                onChange={e =>
                  setSettings(prev => ({
                    ...prev,
                    marketing: e.target.checked
                  }))}
              />{" "}
              Marketingowe
            </label>
            <p className={styles.description}>
              Dzięki nim reklamy, któe widzisz, są bardziej dopasowane do Twoich
              potrzeb i zainteresowań.
            </p>
          </div>
        </div>

        <div className={styles.actions}>
          <button onClick={() => setIsOpen(false)} className={styles.cookieBtn}>
            Zamknij
          </button>
          <button
            onClick={handleSave}
            // onClick={() => alert("Zapisano ustawienia!")}
            className={styles.cookieBtn}
          >
            Zapisz
          </button>
        </div>
      </div>
    </div>
  );
}
